import React from 'react';
import {Route, Switch} from 'react-router-dom';
import {YearlyReportV2Container} from '../../report/2022/publicContainer/YearlyReportV2Container';
import {ReportsV2View} from '../../reportsV2/ReportsV2View/ReportsV2View';
import {DashboardNavigationTopBar} from '../dashboard/DashboardNavigationTopBar';

export const PUBLIC_ROUTES_PREFIX = '/uir/pub';
export const PUBLIC_ROUTES = {
  YEAR_REPORT: `${PUBLIC_ROUTES_PREFIX}/year-report/:id`,
  STREAM_REPORT: `/stream-report/:id`,
};

export const PublicRoutes = () => {
  return (
    <Switch>
      <Route
        path={PUBLIC_ROUTES.YEAR_REPORT}
        exact
        component={YearlyReportV2Container}
      />

      <div>
        <DashboardNavigationTopBar isPublic />

        <Route
          path={PUBLIC_ROUTES.STREAM_REPORT}
          exact
          render={(props) => <ReportsV2View {...props} isPublic />}
        />
      </div>
    </Switch>
  );
};
